module.exports = __webpack_public_path__ + "static/media/4-menu.78e1a5bb.svg";